import { css } from '@emotion/react';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';
import ParticipantQuestionDisplay from './participant-question-display';

const styles = css`
  white-space-collapse: break-spaces;
  line-height: 37px;
`;

type MentoringQuestionsDisplayProps = {
  questionText: string;
  menteeQuestion?: string;
  mentorQuestion?: string;
};

const MentoringQuestionsDisplay = ({
  questionText,
  menteeQuestion,
  mentorQuestion,
}: MentoringQuestionsDisplayProps) => (
  <div className='d-flex flex-row align-items-center question-text'>
    {menteeQuestion && mentorQuestion ? (
      <span css={styles}>
        <ParticipantQuestionDisplay
          question={menteeQuestion}
          role={MentoringProgramRole.MENTORSHIP_PROGRAM_MENTEE}
        />
        <ParticipantQuestionDisplay
          question={mentorQuestion}
          role={MentoringProgramRole.MENTORSHIP_PROGRAM_MENTOR}
        />
      </span>
    ) : (
      <ParticipantQuestionDisplay
        question={questionText}
        role={MentoringProgramRole.MENTORSHIP_PROGRAM_ADMIN}
      />
    )}
  </div>
);

export default MentoringQuestionsDisplay;
